import { AIButtonText as AIButtonTextButton } from '../../AIButton'
import { BUTTON_HEIGHT_24 } from '../../Button'
import { Container } from '../Container'

import PlusIcon from '../../../icons/plus.svg'

const AI_TEXT_BUTTON_SIZES = [BUTTON_HEIGHT_24]

const AI_TEXT_ICON_SIZES = [BUTTON_HEIGHT_24]

export function AIButtonText() {
  return (
    <>
      <Container label='AI Button, text, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton height={size} key={size} text='Button' />
        ))}
      </Container>
      <Container label='AI Button, text, disabled, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton disabled height={size} key={size} text='Button' />
        ))}
      </Container>
      <Container label='AI Button, text, with loader, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton
            isLoading
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text, with pre icon, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text, with pre icon, with loader, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text, with post icon, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton
            afterIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text, with post icon, with loader, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton
            isLoading
            afterIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text, with skeleton, sizes - 24px'>
        {AI_TEXT_BUTTON_SIZES.map(size => (
          <AIButtonTextButton
            isSkeleton
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text, icon, sizes - 24px'>
        {AI_TEXT_ICON_SIZES.map(size => (
          <AIButtonTextButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, text, icon, disabled, sizes - 24px'>
        {AI_TEXT_ICON_SIZES.map(size => (
          <AIButtonTextButton
            disabled
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, text, icon, with loader, sizes - 24px'>
        {AI_TEXT_ICON_SIZES.map(size => (
          <AIButtonTextButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, text, icon, with skeleton, sizes - 24px'>
        {AI_TEXT_ICON_SIZES.map(size => (
          <AIButtonTextButton
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
